<div >
  <img height="75" src="https://www.flacriminallawyer.com/wp-content/uploads/2015/12/Fort-Lauderdale-Criminal-Attorney-Jonathan-Friedman-Logo.jpg" />
  <br /><br />
  <h3>
    Auto Brief Generator</h3>

  <div>
    <a href="/jfriedman/authorize">Authorize this app to use your Google Account (drive and docs)</a>
  </div>


  <!-- <div>
    <a href="/jfriedman/generatedocument">Generate a Sample Document</a>
  </div> -->
  
<div>



  <br /><br /><br /><br /><br /><br /><br />
</div>